// extracted by mini-css-extract-plugin
export default {"dnb_sidebarMenuContentWrapper":"MenuTab-module--dnb_sidebarMenuContentWrapper--bebbc","mobileMenuView":"MenuTab-module--mobileMenuView--27f9b"};